/* unplugin-vue-components disabled */import { render } from "./domeditor.vue?vue&type=template&id=76fdcaa5&scoped=true"
import script from "./domeditor.vue?vue&type=script&lang=js"
export * from "./domeditor.vue?vue&type=script&lang=js"

import "./domeditor.vue?vue&type=style&index=0&id=76fdcaa5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fdcaa5"]])

export default __exports__